import type { JobThread } from '../types/foreman';
import styles from './JobThread.module.css';

interface JobThreadItemProps {
  thread: JobThread;
  active: boolean;
  onClick: () => void;
}

const STATUS_COLORS: Record<string, string> = {
  active: 'var(--blue)',
  ready: 'var(--green)',
  attention: 'var(--red)',
  complete: 'var(--dim)',
};

export function JobThreadItem({ thread, active, onClick }: JobThreadItemProps) {
  return (
    <div
      className={`${styles.thread} ${active ? styles.active : ''}`}
      onClick={onClick}
    >
      <div className={styles.header}>
        <span className={`${styles.name} ${thread.unread > 0 ? styles.unread : ''}`}>
          {thread.name}
        </span>
        {thread.unread > 0 && (
          <span className={styles.badge}>{thread.unread}</span>
        )}
      </div>
      <div className={styles.meta}>
        <code className={styles.code}>{thread.code}</code>
        <span
          className={styles.status}
          style={{ background: STATUS_COLORS[thread.status] || 'var(--dim)' }}
        >
          {thread.status}
        </span>
      </div>
      <div className={styles.preview}>{thread.lastMessage}</div>
    </div>
  );
}
